import { baseApi } from "@/config/http-common";
import { AxiosPromise } from "axios";

export interface TenantSummary {
  id: string;
  name: string;
  bin: string;
  status: "ACTIVE" | "DISABLE" | "DISABLED";
  rootCompanyId: string;
  administratorUserId?: string;
  logoFileGuid?: string | null;
}

export interface TenantPage {
  content: TenantSummary[];
  totalPages: number;
  totalElements: number;
}

interface GlobalResponse<T> {
  status: boolean;
  message: string;
  data: T;
}

export interface TenantAdministratorRequest {
  login: string;
  email: string;
  password: string;
  iin: string;
  name: string;
  middleName?: string;
  surname: string;
}

export interface TenantProvisionRequest {
  name: string;
  bin: string;
  administrator: TenantAdministratorRequest;
}

export interface TenantUpdateRequest {
  name: string;
  bin: string;
}

class TenantDataService {
  getAll(page = 0, size = 20): AxiosPromise<GlobalResponse<TenantPage>> {
    return baseApi.get("/platform/tenants", { params: { page, size } });
  }

  provision(
    data: TenantProvisionRequest
  ): AxiosPromise<GlobalResponse<TenantSummary>> {
    return baseApi.post("/platform/tenants", data);
  }

  update(
    id: string,
    data: TenantUpdateRequest
  ): AxiosPromise<GlobalResponse<TenantSummary>> {
    return baseApi.put(`/platform/tenants/${id}`, data);
  }

  updateStatus(
    id: string,
    status: "ACTIVE" | "DISABLED"
  ): AxiosPromise<GlobalResponse<TenantSummary>> {
    return baseApi.put(`/platform/tenants/${id}/status`, { status });
  }

  uploadLogo(
    id: string,
    file: File
  ): AxiosPromise<GlobalResponse<TenantSummary>> {
    const formData = new FormData();
    formData.append("file", file, file.name);
    return baseApi.put(`/platform/tenants/${id}/logo`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  getLogo(id: string): AxiosPromise<Blob> {
    return baseApi.get(`/platform/tenants/${id}/logo`, {
      responseType: "blob",
      silent: true,
    } as any);
  }

  deleteLogo(id: string): AxiosPromise<GlobalResponse<TenantSummary>> {
    return baseApi.delete(`/platform/tenants/${id}/logo`);
  }
}

export default new TenantDataService();
